import Passenger from "../models/Passenger";
import Slice from "../models/Slice";

interface KoalaFlight {
  airlineIata: string;
  number: string;
  departureAirportIata: string;
  arrivalAirportIata: string;
  departureDate: string;
  arrivalDate: string;
}
const parseFlightDataToKoala = (
  passengers: Passenger[],
  slices: Slice[],
  currency: string,
  totalCost: number
) => {
  let singleSeg: KoalaFlight;
  let koalaFlight: KoalaFlight[] = []; // contains several flights segments
  let koalaFlightKey = {
    flights: koalaFlight,
  };

  let koalaFlights: KoalaFlight[] = []; // contains several flights segments

  const koalaJourneys: any[] = []; // contains several flights

  for (let i = 0; i < slices.length; i++) {
    koalaFlight = [];
    const slice = slices[i];
    const segs = slice.segments;
    //    console.log("Slice from parse : ", slice);

    for (let j = 0; j < segs.length; j++) {
      const seg = segs[j];
      singleSeg = {
        airlineIata: seg.operating_carrier.iata_code,
        number: seg.operating_carrier_flight_number,
        departureAirportIata: seg.origin.iata_code,
        arrivalAirportIata: seg.destination.iata_code,
        departureDate: new Date(seg.departing_at).toISOString(),
        arrivalDate: new Date(seg.arriving_at).toISOString(),
      };
      koalaFlight.push(singleSeg);
    }
    //    console.warn("KOALA FLIGHT: ", koalaFlight);
    koalaFlightKey.flights = koalaFlight;
  }
  koalaJourneys.push(koalaFlightKey);

  //  console.warn("KOALA JOURNEY: ", koalaJourneys[0]);

  let voyageurs: any[] = [];

  for (let index = 0; index < passengers.length; index++) {
    const pass = passengers[index];
    let passRange = pass.type.split("_")[0];
    let voyageur = {
      ageRange: passRange.toUpperCase(),
    };
    voyageurs.push(voyageur);
  }
  //  console.warn("KOALA TRAVELERS: ", voyageurs);

  let temp = {
    data: {
      currency: currency,
      trips: [
        {
          price: {
            amount: totalCost,
            currency: currency,
          },
          journeys: [
            {
              flights: koalaFlight,
            },
          ],
          travelers: voyageurs,
        },
      ],
    },
  };
  console.log("====================================");
  console.log("FINAL KOAL PAYLOAD TO SEND: ", temp);
  console.log("====================================");
  return temp;
};

export default parseFlightDataToKoala;
